import { useQuery, QueryObserverBaseResult } from "react-query"
import { queryKeys } from "../query"
import api from "../client"
import { WelcomeResponse } from "../types/misc"

const getData = async () => {
  const { data } = await api.get(`/welcome`)
  return data
}

export const useWelcome = (): QueryObserverBaseResult<WelcomeResponse> => {
  const { data, ...props } = useQuery<WelcomeResponse>(
    queryKeys.WELCOME,
    () => getData(),
  )
  return { data, ...props }
}
